import { Component, OnInit, OnDestroy, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ChatSessionService } from 'src/app/services/chat-session.service';

@Component({
  selector: 'app-chat-view-container',
  templateUrl: './chat-view-container.component.html',
  styleUrls: ['./chat-view-container.component.scss']
})
export class ChatViewContainerComponent implements OnInit, OnChanges, OnDestroy {
  private destroy$ = new Subject<void>();
  private openChats = new Map<string, any>();
  private MAX_VISIBLE_CHATS = 2;

  get visibleChats(): any[] {
    return Array.from(this.openChats.values()).reverse().slice(0, this.MAX_VISIBLE_CHATS);
  }

  get hiddenChats(): any[] {
    return Array.from(this.openChats.values()).reverse().slice(this.MAX_VISIBLE_CHATS);
  }
  
  @Input() isJob = false;
  @Input() profiles: any[] = [];
  @Input() jobId: any = null;
  @Input() jobInfo: any;

  constructor( 
    private chatSessionService: ChatSessionService
  ) {}

  public ngOnInit() {
    this.chatSessionService.getNewChat$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(profiles => {
        if (profiles.length > 1) {
          this.openChats.set('bulk', profiles);
        } else {
          if (!this.openChats.has(profiles[0].profileRef)) {
            this.openChats.set(profiles[0].profileRef, profiles);
          }
        }
      });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['profiles']) {
      const newProfiles: any[] = changes['profiles'].currentValue;

      for (const profile of newProfiles) {
        if (!this.openChats.has(profile.profileRef)) {
          this.openChats.set(profile.profileRef, profile);
        }
      }
    }
  } 

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private openChat(profile: any) {
    const profileRef = profile.profileRef;
    if (!this.openChats.has(profileRef)) {
      this.openChats.set(profileRef, profile);
    }

  }

  public closeChat(profileId: string) {
    this.openChats.delete(profileId);
  }

  public promoteHiddenChat(chatToPromote: any): void {
    const chat = chatToPromote.length > 1 ? 'bulk' : chatToPromote[0].profileRef;
    const allChats = Array.from(this.openChats.entries()).reverse();

    const visible = allChats.slice(0, this.MAX_VISIBLE_CHATS);
    const hidden = allChats.slice(this.MAX_VISIBLE_CHATS);

    const indexInHidden = hidden.findIndex(([key]) => key === chat);
    if (indexInHidden === -1 || visible.length < 1) return;

    const promotedChat = hidden[indexInHidden];
    const firstVisible = visible[0];

    const newReversedList: [string, any][] = [];

    newReversedList.push(promotedChat);

    if (firstVisible) {
      newReversedList.push(firstVisible);
    }

    const remainingHidden = [
      ...hidden.filter((_, i) => i !== indexInHidden),
      ...visible.slice(1)
    ];

    newReversedList.push(...remainingHidden);

    this.openChats = new Map(newReversedList.reverse());
  }
}